import React, { Fragment } from "react";
import { useSpring, animated } from "react-spring";
import { homeUrl } from "../settings";

// Dependencies

// Styles
import styled from "styled-components";
import { themeColors, fontFamily, fontWeight } from "../Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignOut,
  faTimes,
  faUnlock,
  faHome,
  faLayerGroup,
  faCog,
  faHospitalAlt
} from "@fortawesome/pro-light-svg-icons";

export default function Menu(props) {
  const { user } = props;
  return (
    <Fragment>
      <MenuContainer style={props.style}>
        <div onClick={props.toggleMenu} className="close">
          <span>Close Menu</span>
          <FontAwesomeIcon icon={faTimes} />
        </div>
        <div className="drawer-menu-item">
          <a href="https://medzcool.com">
            <FontAwesomeIcon icon={faHome} />
            <span>Dashboard</span>
          </a>
        </div>
        <div className="drawer-menu-item">
          <a href="/">
            <FontAwesomeIcon icon={faLayerGroup} />
            <span>Collections</span>
          </a>
        </div>
        <div className="drawer-menu-item">
          <a href="/clinic">
            <FontAwesomeIcon icon={faHospitalAlt} />
            <span>Clinic</span>
          </a>
        </div>
        <div className="drawer-menu-item">
          <a href="https://medzcool.com/change-password">
            <FontAwesomeIcon icon={faUnlock} />
            <span>Change Password</span>
          </a>
        </div>
        {user.profile.subscriptionStatus && (
          <div className="drawer-menu-item">
            <a href="https://medzcool.com/settings">
              <FontAwesomeIcon icon={faCog} />
              <span>Account Settings</span>
            </a>
          </div>
        )}

        <div
          className="drawer-menu-item"
          onClick={() => {
            props.logout();
            window.location = `${homeUrl}`;
          }}
        >
          <FontAwesomeIcon icon={faSignOut} />
          <span>Logout</span>
        </div>
      </MenuContainer>
      <MenuBackground style={props.opacity} onClick={props.toggleMenu} />
    </Fragment>
  );
}

const MenuContainer = styled(animated.div)`
  font-family: ${fontFamily.sansSerif};
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 300px;
  color: white;
  background: #1d1d1d;
  z-index: 1;
  padding: 25px;
  .drawer-menu-item {
    cursor: pointer;
    span {
      margin-left: 15px;
      font-weight: 500;
    }
    padding: 10px;
    margin: 15px 0;
  }
  .close {
    cursor: pointer;
    text-align: right;
    margin-bottom: 25px;
    border-bottom: 1px solid gray;
    padding-bottom: 25px;
    span {
      margin-right: 15px;
    }
  }
  @media (max-width: 425px) {
    width: 100%;
    padding: 0;
    .close {
      padding: 25px;
    }
    .drawer-menu-item {
      text-align: center;
    }
  }
`;
const MenuBackground = styled(animated.div)`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: black;
`;
